import { getMessageFactory } from "../getCaxaWebSocket.js";
const getCurrentCupboardInfo = getMessageFactory({
  code: "GET_CURRENT_CUPBOARD_INFO"
});
export { getCurrentCupboardInfo };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/getCurrentCupboardInfo.js